import { Button, Form, Input, Menu, message, Modal, Popover, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import {
	NAV_STYLE_FIXED,
	NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
	NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
	THEME_TYPE_LITE
} from '../../constants/ThemeSetting';
import CustomScrollbars from '../../util/CustomScrollbars';
import SidebarLogo from './SidebarLogo';
import './SidebarContent.css';
import { FaGgCircle } from 'react-icons/fa';
import { LiaStumbleuponCircle } from 'react-icons/lia';
import { CgCircleci } from 'react-icons/cg';
import { IoChatbox } from 'react-icons/io5';
import { IoCheckmarkDoneCircle } from 'react-icons/io5';
import { IoEllipsisHorizontalCircleSharp } from 'react-icons/io5';
import { MdFlagCircle } from 'react-icons/md';
import { MdLightbulbCircle } from 'react-icons/md';
import { MdCloudCircle } from 'react-icons/md';
import { Typewriter } from 'react-simple-typewriter';
import { SiChatbot } from 'react-icons/si';
import { fetchHistoryChats, historyChatsReset } from '../../redux/chatApp/HistoryChat';
import { fetchNewChat } from '../../redux/chatApp/NewChat';
import { resetSpecificChat, specificChat } from '../../redux/chatApp/SpecificChat';
import { CgMoreO } from 'react-icons/cg';
import { RiDeleteBin5Fill } from 'react-icons/ri';
import { FaEdit } from 'react-icons/fa';
import { chatEdit, resetEditSlice } from '../../redux/chatApp/chatEditSlice';
import { GiSplitCross } from 'react-icons/gi';
import { renameChat, resetRenameSlice } from '../../redux/chatApp/renameChatSlice';
import { IoAlertCircle } from 'react-icons/io5';

const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }: any) => {
	const { navStyle, themeType } = useSelector(({ settings }: any) => settings),
		pathname = useSelector(({ common }: any) => common.pathname),
		getNoHeaderClass = (navStyle: any) => {
			if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
				return 'gx-no-header-notifications';
			}
			return '';
		},
		getNavStyleSubMenuClass = (navStyle: any) => {
			if (navStyle === NAV_STYLE_FIXED) {
				return 'gx-no-header-submenu-popup ant-menu-item-selected';
			}
			return '';
		},
		selectedKeys = pathname.substr(1),
		defaultOpenKeys = selectedKeys.split('/')[1],
		selectMenusData = (state: any) => state?.menus?.menusData,
		menusData = useSelector(selectMenusData),
		[openedMenu, setOpenedMenu] = useState<any>(null),
		[count, setCount] = useState(1),
		[selectedMainMenu, setSelectedMainMenu] = useState<string>(''),
		handleMenuClick = (menuId: any) => {
			if (openedMenu === menuId) {
				// setOpenedMenu(null);
			} else {
				// setOpenedMenu(menuId);
			}
		},
		location = useLocation();

	const { specificChatResponse, status: specificChatLoader, lastRequest, newStatus } = useSelector((state: any) => state?.specificChatReducer);

	useEffect(() => {
		menusData?.data?.Menu?.map((menu: any) => {
			menu?.subMenu?.map((submenu: any) => {
				if (submenu.Url === location.pathname) {
					setOpenedMenu(submenu.id);
					setSelectedMainMenu(menu.MenuId);
					setCount(count + 1);
				}
			});
		});
	}, [location.pathname, menusData, selectedMainMenu]);

	// useEffect(() => {}, [openedMenu, selectedMainMenu, count]);

	const icons: any = [
		<LiaStumbleuponCircle size={20} />,
		<CgCircleci size={20} />,
		<IoChatbox size={20} />,
		<IoCheckmarkDoneCircle size={20} />,
		<IoEllipsisHorizontalCircleSharp size={20} />,
		<MdFlagCircle size={20} />,
		<MdLightbulbCircle size={20} />,
		<MdCloudCircle size={20} />
	];

	const RandomIcon = icons[Math.floor(Math.random() * icons.length)];

	const { historyChatsData, status: HistoryLoader } = useSelector((state: any) => state?.HistoryChatsReducer);
	const { editresponse, status: editLoader } = useSelector((state: any) => state?.editSliceReducer);
	const { renameResponse, status: renameLoader } = useSelector((state: any) => state?.renameSliceReducer);
	const { newChatData, status: newChatLoader } = useSelector((state: any) => state?.NewChatReducer);
	const [selectedIndex, setSelectedIndex] = useState<number | null>(0);

	const dispatch = useDispatch();
	const [historyTab, setHistoryTab] = useState<any>([]);

	const [openRename, setOpenRename] = useState(false);
	const [deleteConfirm, setDeleteConfirm] = useState(false);

	useEffect(() => {
		dispatch(fetchHistoryChats());
		dispatch(historyChatsReset());
	}, []);
	// }, [newChatData?.statusCode === 200]);

	useEffect(() => {
		if (historyChatsData?.statusCode == 200) {
			setHistoryTab(historyChatsData?.data);
			dispatch(historyChatsReset());
		} else if (historyChatsData?.statusCode == 400 || historyChatsData?.statusCode == 500) {
			// message?.warning(historyChatsData?.message);
			console.error(historyChatsData?.message);
			dispatch(historyChatsReset());
		}
	}, [historyChatsData?.statusCode]);

	useEffect(() => {
		if (editresponse?.statusCode === 200) {
			setDeleteConfirm(false);
			dispatch(fetchHistoryChats());
			dispatch(fetchNewChat())
			setSelectedIndex(null)
			message?.success(editresponse?.message);
			dispatch(resetEditSlice());
		} else if (editresponse?.statusCode === 400 || editresponse?.statusCode === 500) {
			message?.warning(editresponse?.message);
			// console.error(editresponse?.message);
			dispatch(resetEditSlice());
		}
	}, [editresponse?.statusCode]);

	useEffect(() => {
		if (renameResponse?.statusCode === 200) {
			setOpenRename(false);
			dispatch(fetchHistoryChats());
			message?.success(renameResponse?.message);
			dispatch(resetRenameSlice());
		} else if (renameResponse?.statusCode === 400 || renameResponse?.statusCode === 500) {
			message?.warning(
				<p className="gx-p-0 gx-m-0 gx-fs-sm" style={{ fontFamily: 'NoirPro' }}>
					{renameResponse?.message}{' '}
				</p>
			);
			// console.error(renameResponse?.message);
			dispatch(resetRenameSlice());
		}
	}, [renameResponse?.statusCode]);

	const getClickedHistory = (chatGuid: any) => {
		if (chatGuid) {
			dispatch(
				specificChat({
					ChatSessionGuId: chatGuid
				})
			);
		}
	};

	const handleNewChat = () => {
		dispatch(fetchNewChat());
		setSelectedIndex(0);
	};

	const handleDeleteOpenModal = (chatsession: any) => {
		setDeleteConfirm(true);
		setSelectedSession(chatsession);
	};

	const handleDeleteClick = () => {
		dispatch(
			chatEdit({
				ChatSessionGuId: selectedsession
			})
		);
	};

	const [selectedsession, setSelectedSession] = useState<any>();
	const [selectedChatName, setSelectedChatName] = useState<any>();
	const [form] = Form.useForm();

	const handleOpenModal = (chatsession: any, chatName: any) => {
		setOpenRename(true);
		setSelectedSession(chatsession);
		setSelectedChatName(chatName);

		form.setFieldsValue({ chatName });
	};

	const handleRename = (values: any) => {
		dispatch(
			renameChat({
				ChatSessionGuId: selectedsession,
				Name: values?.chatName
			})
		);
		// setOpenRename(false);
	};

	return (
		<>
			<SidebarLogo sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />
			<div className="gx-sidebar-content" style={{ maxHeight: 'calc(88vh - 20px)', overflowY: 'scroll' }}>
				{' '}
				{/* gx-sidebar-notifications */}
				<div className={` ${getNoHeaderClass(navStyle)}`}>
					{/* <UserProfile />
          <AppsNavigation /> */}
				</div>
				{/* {selectedMainMenu && ( */}
				<CustomScrollbars className="gx-layout-sider-scrollbar">
					<Menu
						// defaultOpenKeys={[selecte	dMainMenu.toString()]}
						// selectedKeys={[selectedKeys]}
						theme={themeType === THEME_TYPE_LITE ? 'light' : 'dark'}
						mode="inline"
					>
						<div className="firestars"></div>
						<div className="firestars2"></div>
						<div className="firestars3"></div>

						<MenuItemGroup key="main" className={`gx-menu-group gx-d-flex gx-pt-4 ${sidebarCollapsed ? 'gx-pl-5' : 'gx-pl-0'}`} title={''}>
							<div>
								{!historyTab?.some((item: any) => item?.chatName === 'New Chat') && (
									<div
										className="gx-d-flex gx-align-items-center gx-p-0 gx-m-0 gx-fs-sm gx-mb-3"
										style={{ paddingLeft: '4px', fontFamily: 'NoirPro', cursor: 'pointer', color: '#ffce00' }}
										onClick={handleNewChat}
									>
										<Tooltip
											title={
												<p className="gx-p-0 gx-m-0" style={{ fontFamily: 'NoirPro' }}>
													New Chat
												</p>
											}
											placement="right"
										>
											<SiChatbot size={20} className="gx-m-0 gx-mr-2 gx-p-0" />
										</Tooltip>
										{/* <p className="gx-p-0 gx-m-0" style={{ fontFamily: 'NoirPro' }} onClick={handleNewChat}>
											<Typewriter words={['New Chat']} typeSpeed={170} cursor loop />
										</p> */}

										{!sidebarCollapsed && (
											<Tooltip
												title={
													<p className="gx-p-0 gx-m-0" style={{ fontFamily: 'NoirPro' }}>
														New Chat
													</p>
												}
												placement="right"
											>
												<p className="gx-p-0 gx-m-0" style={{ fontFamily: 'NoirPro' }}>
													<Typewriter words={['New Chat']} typeSpeed={170} cursor loop />
												</p>
											</Tooltip>
										)}
									</div>
								)}
							</div>

							{historyTab?.map((menu: any, index: number) => (
								<div className="gx-d-flex gx-justify-content-between gx-align-items-center gx-p-0 gx-m-0 gx-fs-sm " style={{ fontFamily: 'NoirPro' }}>
									<Tooltip
										title={
											<p className="gx-p-0 gx-m-0" style={{ fontFamily: 'NoirPro' }}>
												{' '}
												{menu?.chatName}
											</p>
										}
										placement="right"
									>
										<div
											className={`gx-d-flex gx-align-items-center gx-mb-3 ${selectedIndex === index ? 'ant-menu-item-selected' : ''}`}
											style={{ cursor: 'pointer', color: index === 0 ? '#ffce00' : '' }}
											onClick={() => {
												setSelectedIndex(index);
												getClickedHistory(menu?.chatSessionGuId);
												setSelectedIndex(index);
											}}
										>
											<SiChatbot size={20} className="gx-m-0 gx-mr-2 gx-p-0" />

											{!sidebarCollapsed && (
												<p className="gx-p-0 gx-m-0" style={{ fontFamily: 'NoirPro' }}>
													{menu?.chatName?.length > 10 ? `${menu?.chatName?.slice(0, 20)}...` : menu?.chatName}
												</p>
											)}
										</div>
									</Tooltip>

									<Popover
										zIndex={8000}
										placement="right"
										content={
											<div
												style={{
													width: '100%',
													fontFamily: 'NoirPro',
													display: 'flex',
													flexDirection: 'column'
													// justifyContent: 'end',
													// alignItems: 'end'
												}}
											>
												<p
													className="gx-p-0 gx-m-0 gx-d-flex gx-align-content-center gx-mb-1 gx-fs-sm gx-link"
													onClick={() => handleOpenModal(menu?.chatSessionGuId, menu?.chatName)}
												>
													{' '}
													<FaEdit size={15} className="gx-mr-1 gx-link" />
													Rename Chat
												</p>
												<hr className="gx-p-0 gx-m-2" />
												<p
													className="gx-p-0 gx-m-0 gx-d-flex gx-align-content-center gx-fs-sm gx-link"
													onClick={() => handleDeleteOpenModal(menu?.chatSessionGuId)}
													style={{ color: 'red' }}
												>
													{' '}
													<RiDeleteBin5Fill size={17} className="gx-mr-1" /> Delete Chat
												</p>
											</div>
										}
										trigger="click"
									>
										{!sidebarCollapsed && menu?.chatName !== 'New Chat' && <CgMoreO size={14} className="gx-m-0 gx-p-0 gx-ml-2 gx-mb-3 gx-link" />}
									</Popover>
								</div>
							))}
						</MenuItemGroup>
					</Menu>
				</CustomScrollbars>
			</div>


			{/* <div className="ant-row ant-row-left gx-mb-2 gx-ml-3">
				{sidebarCollapsed ? (
					""
				) : (
					<img src="/assets/images/prowesslogo.png" alt="Full Logo" width={80} />
				)}
			</div> */}
			<div
				className="gx-p-0 gx-px-3 gx-pb-1 gx-m-0"
				style={{
					position: 'absolute',
					bottom: 0,
					left: 0,
					right: 0,
					backgroundColor: '#2B2A33',
					textAlign: 'left',
					padding: '8px 16px',
				}}
			>
				{sidebarCollapsed ? (
					""
				) : (
					<img src="/assets/images/prowesslogo.png" alt="Full Logo" width={80} />
				)}
			</div>

			<Modal
				open={openRename}
				onCancel={() => setOpenRename(false)}
				// style={{ top: '10%' }}
				// style={{ top: 4 }}
				// width={1300}
				okText={false}
				cancelText={false}
				footer={false}
				closeIcon={false}
			>
				{/* eslint-disable-next-line  */}
				{/* <div className="table-container gx-p-3 " dangerouslySetInnerHTML={{ __html: tabledata }}></div> */}
				<div style={{ overflow: 'auto' }} className="gx-mb-0">
					<div className="gx-d-flex gx-align-items-center gx-mb-2">
						<FaEdit size={15} className="gx-m-0 gx-p-0 gx-mr-1 gx-link gx-fs-sm" />
						<p className="gx-m-0 gx-p-0 gx-font-weight-semi-bold gx-fs-sm">Rename Chat</p>
					</div>
					{/* <Input
						className="gx-fs-sm gx-mt-2"
						type="text"
						maxLength={500}
						value={selectedChatName}
						onChange={(e: any) => setSelectedChatName(e.target.value)}
					/> */}

					<Form form={form} layout="vertical" onFinish={handleRename}>
						<Form.Item
							name="chatName"
							rules={[
								{
									required: true,
									message: (
										<p className="gx-p-0 gx-m-0 gx-fs-sm" style={{ fontFamily: 'NoirPro' }}>
											Please enter chat name
										</p>
									)
								},
								{
									pattern: /^(?!\s*$).+/,
									message: (
										<p className="gx-p-0 gx-m-0 gx-fs-sm" style={{ fontFamily: 'NoirPro' }}>
											Chat Name cannot be empty or spaces only
										</p>
									)
								},
								({ getFieldValue }) => ({
									validator(_, value) {
										if (value?.trim().toLowerCase() === 'new chat') {
											return Promise.reject(
												<p className="gx-p-0 gx-m-0 gx-fs-sm" style={{ fontFamily: 'NoirPro' }}>
													Chat Name cannot be "New Chat"
												</p>
											);
										}
										return Promise.resolve();
									}
								})
							]}
						>
							<Input type="text" maxLength={500} />
						</Form.Item>

						<div className="gx-d-flex gx-align-items-center gx-mt-2" style={{ justifyContent: 'end', fontFamily: 'NoirPro' }}>
							<Button size="small" onClick={() => setOpenRename(false)} style={{ fontFamily: 'NoirPro' }}>
								Cancel
							</Button>
							<Button
								type="primary"
								style={{ fontFamily: 'NoirPro' }}
								onClick={handleRename}
								htmlType="submit"
								size="small"
								disabled={!selectedChatName}
							>
								Submit
							</Button>
						</div>
					</Form>
				</div>
			</Modal>
			<Modal
				open={deleteConfirm}
				onCancel={() => setDeleteConfirm(false)}
				// style={{ top: '10%' }}
				// style={{ top: 4 }}
				// width={1300}
				okText={false}
				cancelText={false}
				footer={false}
				// closeIcon={<GiSplitCross title="close" size={17} className="gx-m-0 gx-mr-3 gx-p-0 gx-fs-sm gx-text-danger" />}
				closeIcon={false}
			>
				{/* eslint-disable-next-line  */}
				{/* <div className="table-container gx-p-3 " dangerouslySetInnerHTML={{ __html: tabledata }}></div> */}
				<div className="gx-mb-2">
					<div className="gx-d-flex gx-align-items-center">
						<IoAlertCircle size={18} color="orange" className="gx-m-0 gx-p-0 gx-mr-1 gx-link gx-fs-sm" />
						<p className="gx-m-0 gx-p-0 gx-font-weight-semi-bold gx-fs-sm">Are you sure you want to delete this chat ?</p>
					</div>

					<div className="gx-d-flex gx-align-items-center gx-mt-2 gx-mr-3 gx-mt-3" style={{ justifyContent: 'end', gap: '27px' }}>
						<Button size="small" className="gx-m-0 " style={{ fontFamily: 'NoirPro' }} onClick={() => setDeleteConfirm(false)}>
							Cancel
						</Button>
						<Button type="primary" className="gx-m-0" style={{ fontFamily: 'NoirPro' }} size="small" onClick={handleDeleteClick}>
							Submit
						</Button>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default React.memo(SidebarContent);
